/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { fetchTimeout } from "../components/Common";
import { API_BASE, Palette } from "../AppConfig";

import * as BSL_Common from "../components/BSL_CommonControls";
import { LinearProgress } from "@material-ui/core";
import SegmentedButtonGroup from "../components/SegmentedButtonGroup";
import Message from "../components/Message";
import BSL_TextInput from "../components/BSL_TextInput";
import BSL_Select from "../components/BSL_Select";
import BSL_DatePicker from "../components/BSL_DatePicker";
import BSL_UploadDocument from "../components/BSL_Upload/BSL_UploadDocument";
import BSL_Button from "../components/BSL_Button";
import { Add } from "@material-ui/icons";

const useStyles = makeStyles({
    root: {
        width: "98%",
        display: "flex",
        flexDirection: "column",
        height: "90%",
        overflow: "auto",
    },
});

export default function SystemTools(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const user = useSelector((state) => state.app.user);
    const [intialise, setIntialise] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    const [announcementList, setAnnouncementList] = React.useState([]);
    const [currentAnnouncement, setCurrentAnnouncement] = React.useState({});
    // const [selectedAnnouncement, setSelectedAnnouncement] = React.useState({});
    const [showMessage, setShowMessage] = React.useState(false);
    const inputRef = React.useRef(null);
    const [fileinputKey, setFileinputKey] = React.useState(0);
    const [ts, setTs] = React.useState(Date.now());

    // const [password, setPassword] = React.useState("");
    // const rows = useSelector(state => state.app.user_last_jobs_edited);

    const updateAnnouncement = (param) => (e, value) => {
        let val = value ? value : e;
        if (val?.target?.value) val = e?.target?.value;

        console.log("updateAnnouncement", param, val);
        let new_currentAnnouncement = { ...currentAnnouncement };
        new_currentAnnouncement[param] = val;
        setCurrentAnnouncement(new_currentAnnouncement);
    };

    React.useEffect(() => {
        if (!intialise) {
            let api_url = API_BASE() + "admin/getannouncementsall";
            if (window.LYSAGHT) api_url = API_BASE() + "admin/getannouncementsall/?b=L";
            fetchTimeout(api_url, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((json) => {
                    console.log(json);
                    if (json.Message) throw json.Message;
                    setAnnouncementList(json);
                    setLoading(false);
                    setIntialise(true);
                })
                .catch((e) => {
                    console.log("ERROR", e);
                    setAnnouncementList([]);
                });
        }
    }, [intialise]);

    const saveAnnouncement = () => {
        let api_url = API_BASE() + "admin/putannouncement";
        if (window.LYSAGHT) api_url = API_BASE() + "admin/putannouncement/?b=L";
        fetchTimeout(api_url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(currentAnnouncement),
        })
            .then(async (response) => {
                if (response.status >= 200 && response.status <= 300) {
                    setLoading(true);
                    setIntialise(false);
                } else {
                    throw await response.text();
                }
            })
            .catch((e) => {
                console.log("ERROR", e);
                setShowMessage({
                    type: "error",
                    message: "Annoucement failed to save" + e,
                });
            });
    };

    const handleAddAnnouncement = () => {
        setCurrentAnnouncement({
            id: Math.floor(Math.random() * 9999999999999).toString(),
            DocumentType: window.LYSAGHT ? "LLD_ANNOUNCEMENT" : "ANNOUNCEMENT",
            type: "general",
            status: "disable",
            name: "General Announcement",
            regions: "",
            header: "General Announcement!",
            content: "This is a Announcement.",
            valid_from_ts: "",
            valid_to_ts: "",
            image: "",
            creator: user?.Email,
            action_text: "",
            action_content: "",
            action_link: "",
            _rid: "rANNAJxThE8GAAAAAAAAAA==",
            _self: "dbs/rANNAA==/colls/rANNAJxThE8=/docs/rANNAJxThE8GAAAAAAAAAA==/",
            _etag: '"4b03add0-0000-0700-0000-621d5f990000"',
            _attachments: "attachments/",
            _ts: 1646092185,
        });
    };

    let announcementsSorted = [];
    for (var item of announcementList) {
        announcementsSorted.push({ Key: item.id, Display: item.name });
    }

    return (
        <div className={classes.root}>
            <BSL_Common.SectionContainer>
                <BSL_Common.SectionRow style={{ borderBottom: "1px solid grey", alignItems: "center" }}>
                    <BSL_Select
                        label={"Load Announcement"}
                        style={{ flex: 1, maxWidth: "600px" }}
                        value={currentAnnouncement?.id}
                        tight={true}
                        items={announcementsSorted}
                        onChange={(e) => {
                            for (var item of announcementList) {
                                if (item?.id === e.target.value) setCurrentAnnouncement(item);
                            }
                        }}
                    />
                    <div
                        onClick={handleAddAnnouncement}
                        style={{ paddingTop: "28px", cursor: "pointer", color: Palette.Control.DarkBlueTrans }}
                    >
                        <Add />
                    </div>

                    <div style={{ flex: 1 }} />
                </BSL_Common.SectionRow>
                {loading && <LinearProgress />}

                {currentAnnouncement?.id && (
                    <div
                        style={{
                            display: "flex",
                            overflow: "auto",
                            textAlign: "left",
                            paddingRight: "10px",
                            flexDirection: "column",
                            width: "98%",
                        }}
                    >
                        <BSL_TextInput
                            label="Name"
                            preValidate="name"
                            tight
                            value={currentAnnouncement.name}
                            onBlur={updateAnnouncement("name")}
                        />

                        <BSL_Common.SectionRow>
                            <SegmentedButtonGroup
                                label="Type"
                                style={{ flex: "none" }}
                                value={currentAnnouncement.type}
                                items={["general", "warning"]}
                                onChange={updateAnnouncement("type")}
                            />
                            <SegmentedButtonGroup
                                label="Status"
                                style={{ flex: "none" }}
                                value={currentAnnouncement.status}
                                items={["active", "disable"]}
                                onChange={updateAnnouncement("status")}
                            />
                            <BSL_DatePicker
                                label="Valid From"
                                tight
                                enableWeekends={true}
                                value={currentAnnouncement.valid_from_ts}
                                onChange={(date) =>
                                    updateAnnouncement("valid_from_ts")(new Date(date.setHours(0, 0, 1)).getTime())
                                }
                                style={{ width: "240px", flex: "none" }}
                            />
                            <BSL_DatePicker
                                label="Valid Until"
                                tight
                                enableWeekends={true}
                                value={currentAnnouncement.valid_to_ts}
                                onChange={(date) => {
                                    let new_date_at_end_of_day = date.setHours(23, 59, 59);
                                    console.log("date", date, new_date_at_end_of_day);
                                    updateAnnouncement("valid_to_ts")(new Date(new_date_at_end_of_day).getTime());
                                }}
                                style={{ width: "240px", flex: "none" }}
                            />
                        </BSL_Common.SectionRow>

                        <BSL_TextInput
                            label="Header"
                            tight
                            value={currentAnnouncement.header}
                            onBlur={updateAnnouncement("header")}
                            // error={errorStateUser?.DisplayName}
                            // helperText={"*sync with Salesforce"}
                        />

                        <BSL_UploadDocument
                            buttonText="IMPORT THUMBNAIL..."
                            backgroundText="UPLOAD"
                            onSuccess={(message) => {
                                updateAnnouncement("image")(null, message.filename);
                                setShowMessage(message);
                            }}
                            onError={setShowMessage}
                            onClear={() => {
                                updateAnnouncement("image")(null, "");
                            }}
                            documentFolder="APP_announcements"
                            documentFilename={
                                currentAnnouncement.image ? currentAnnouncement.image : currentAnnouncement.id
                            }
                            documentSaveFilename={currentAnnouncement.id}
                            documentType="logo"
                            sizeLimitMB={2}
                            recompressImage={true}
                            resizeImageByMaxWidth={300}
                            style={{
                                flex: "none",
                                width: "200px",
                            }}
                        />

                        <BSL_UploadDocument
                            buttonText="IMPORT DOCUMENT..."
                            backgroundText="UPLOAD"
                            onSuccess={(message) => {
                                updateAnnouncement("image")(null, message.filename);
                                updateAnnouncement("action_link")(
                                    API_BASE() + "Document/APP_announcements/" + message.filename
                                );
                                setShowMessage(message);
                            }}
                            onError={setShowMessage}
                            onClear={() => {
                                updateAnnouncement("image")(null, "");
                            }}
                            documentFolder="APP_announcements"
                            documentFilename={
                                currentAnnouncement.image ? currentAnnouncement.image : currentAnnouncement.id
                            }
                            documentSaveFilename={currentAnnouncement.id}
                            documentType="logo"
                            sizeLimitMB={2}
                            recompressImage={true}
                            resizeImageByMaxWidth={300}
                            style={{
                                flex: "none",
                                width: "200px",
                            }}
                        />

                        <BSL_Common.SectionColumn
                            style={{
                                flex: 1,
                            }}
                        >
                            <BSL_TextInput
                                label="Content"
                                multiline
                                tight
                                rows={3}
                                style={{
                                    // height: "120px",
                                    flex: 1,
                                }}
                                value={currentAnnouncement.content}
                                onBlur={updateAnnouncement("content")}
                            />
                        </BSL_Common.SectionColumn>

                        <BSL_Common.SectionColumn>
                            <BSL_TextInput
                                label="Action Extra Content/Details"
                                multiline
                                tight
                                rows={2}
                                style={{
                                    // height: "120px",
                                    flex: 1,
                                }}
                                value={currentAnnouncement.action_content}
                                onBlur={updateAnnouncement("action_content")}
                                helperText={
                                    "if this has content, the action becomes 'more info' and this content will be displayed on a pop up. If there is a link action, that will be a button from this pop up."
                                }
                            />
                            <BSL_TextInput
                                label="Action Link Text"
                                tight
                                value={currentAnnouncement.action_text}
                                onBlur={updateAnnouncement("action_text")}
                                // error={errorStateUser?.DisplayName}
                                // helperText={"*sync with Salesforce"}
                            />
                            <BSL_TextInput
                                label="Action Link URL"
                                tight
                                value={currentAnnouncement.action_link}
                                onBlur={updateAnnouncement("action_link")}
                            />
                        </BSL_Common.SectionColumn>

                        <BSL_Button label="SAVE" onClick={saveAnnouncement} />
                    </div>
                )}
            </BSL_Common.SectionContainer>
            <Message
                open={showMessage}
                message={showMessage?.message}
                type={showMessage?.type}
                onClose={() => setShowMessage(null)}
            />
        </div>
    );
}
